const w = window
const d = document
export const root = d.documentElement

export const requestAnimationFrame = w.requestAnimationFrame || w.webkitRequestAnimationFrame || w.mozRequestAnimationFrame;

export const cancelAnimationFrame = w.cancelAnimationFrame || w.webkitCancelAnimationFrame || w.mozCancelAnimationFrame;

export const qs = (selector) => d.querySelector(selector) 

export const css = (node, style) => {
    Object.keys(style).forEach(key => {
        if(key in node.style) {
            node.style[key] = style[key]
        }
    })
}

export const is = {
    str: (a) => typeof a === 'string',
    fnc: (a) => typeof a === 'function',
    node: (a) => a && a.nodeType === Node.ELEMENT_NODE
}

export const on = (node, event, callback, option) => {
    event.split(/\s{1,10}/).forEach((eventType) => {
        node.addEventListener(eventType, callback, option)
    })
}

export const off = (node, event, callback, option) => {
    event.split(/\s{1,10}/).forEach((eventType) => {
        node.removeEventListener(eventType, callback, option)
    })
}

export const validateType = (_data/*<generic*>*/, _types/*<array>*/, _error/*<string>*/) => {
    if(!(_types.includes(typeof(_data))
         || (_types.includes('node') && is.node(_data))))
      throw new Error(`${_error} must contain the following data types (${_types.map((each) => each.toUpperCase()).join(', ')})`)
}

export const applyCoordinate = (target, x, y, axis) => {
    const position = {
        position: 'absolute'
    }
    if(axis === 'x' || !axis) {
        position.left = `${x}px`
    }
    if(axis === 'y' || !axis)  {
        position.top = `${y}px`
    }
    css(target, position);
}

export const getCoordinates = (event, { container, target, isDraggable, prefix, allowBoundContainer }) => { 
    const { clientX, clientY } = (event.touches && event.touches[0]) || event 
    const bound = container.getBoundingClientRect() 
    if(!prefix) {
        const {left = 0, top = 0, width = 0, height = 0} = isDraggable 
        ? target.getBoundingClientRect() 
        : {}
        prefix = { 
            left: clientX - left,
            top: clientY - top,
            width: width,
            height: height,
            containerHeight: container.scrollHeight,
            containerWidth: container.scrollWidth,
        }
    }
    let x = clientX
    let y = clientY
    if(allowBoundContainer) {
        x = getBoundX(container.scrollLeft + (x - bound.left) - (isDraggable ? prefix.left : 0), prefix)
        y = getBoundY(container.scrollTop + (y - bound.top) - (isDraggable ? prefix.top : 0), prefix)
    }
    return {
        clientX,
        clientY,
        x,
        y,
        prefix,
    }
}

export const getDroppable = ({target, droppable, point: { x, y} }) => {
    target.hidden = true
    const droppableNode = d.elementFromPoint(x, y)
    target.hidden = false
    const currentDroppable = droppableNode && droppableNode.closest(droppable)
    const isOverDroppable = currentDroppable && currentDroppable.matches(droppable)
    return {
        droppableNode,
        currentDroppable,
        isOverDroppable
    }
}

export const getBoundY = (y, prefix) => { 
    return Math.max(0, Math.min(prefix.containerHeight - prefix.height, y))
}

export const getBoundX = (x, prefix) => {  
    return Math.max(0, Math.min(prefix.containerWidth - prefix.width, x))
}

export const getAncestorsScrolledTree = (container) => {
    const ancestors = []
    for (let elem = container; elem && elem !== d; elem = elem.parentNode ) {
        if(elem.scrollHeight > elem.clientHeight || elem.scrollWidth > elem.clientWidth) {
            ancestors.push(elem);
        }
    }
    return ancestors 
}

export const getPower = (sensitivity, cut, filler) => Math.min(sensitivity, Math.min(cut, filler > 0 ? filler : cut))

const eventSupported = ['dragstart', 'dragmove', 'dragend', 'dragenter', 'dragover', 'dragexit', 'drop']

export const validateEvent = (type, eventType) => {
    if (!eventSupported.includes(eventType))
        throw new SyntaxError(
            `Dragger.${type} event type "${eventType}" is not recognize. supported events are ${eventSupported.join(
                ', '
            )}`
        );
}

export class DraggerEvent { 
    constructor(event, options){
         Object.assign(this, options)
         this.originalEvent = event
    }
    preventDefault() { this.originalEvent.preventDefault() }
    stopPropagation() { this.originalEvent.stopPropagation() }
}